module.exports = __webpack_public_path__ + "assets/img/iphone.89a434c0.jpg";